import { Controller } from "@hotwired/stimulus"

// Polls the page to detect when generation completes (fallback for WebSocket).
// The actual progress updates come via Turbo Stream broadcasts from the server.
export default class extends Controller {
  static values = {
    generationId: Number
  }

  connect() {
    this.poller = setInterval(() => this.checkStatus(), 10000)
  }

  disconnect() {
    if (this.poller) clearInterval(this.poller)
  }

  async checkStatus() {
    try {
      const response = await fetch(window.location.href, {
        headers: { "Accept": "text/html" }
      })
      const html = await response.text()
      // If the page no longer contains the processing state, reload
      if (!html.includes('id="generation_processing"')) {
        window.location.reload()
      }
    } catch (_e) {
      // Network error — ignore, will retry
    }
  }
}
